module.exports = __webpack_public_path__ + "media/operational-monitoring_de_ipad_air.b80e38ba.mp4";